import axios from "axios";
import { removeToken } from './storageData';

const instance = axios.create({
  baseURL: "https://qsafe24.com.pl/api/"
});

instance.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response;
    if (status === 401) {
      removeToken();
      window.location.reload();
    }
  }
)

export default instance;
